import Component from "@ember/component"
import { inject as service } from "@ember/service"

export default class AdminSidebarRotationCalendar extends Component {
  @service("ember-store")
  store

  canShowActionMenu = false
}
